import * as firebase from "firebase/app";
import "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAvrFR-spd5AclkgQg0ARESvXJmMyX_Ops",
  authDomain: "roonclood.firebaseapp.com",
  databaseURL: "https://roonclood.firebaseio.com",
  projectId: "roonclood",
  storageBucket: "roonclood.appspot.com",
  messagingSenderId: "450111099456",
  appId: "1:450111099456:web:c5e8d2198b3f79dc05c5a5",
};
// Initialize Firebase

firebase.initializeApp(firebaseConfig);
export default firebase;
